import * as type from '../actions/types';
import { devLog } from '../utils';

const initialState = {
  data: null,
  error: '',
  pending: false,
  success: false,
  requestPayoutPending: false,
  requestPayoutSuccess: false,
  requestPayoutError: '',
  sendEnquiryPending: false,
  sendEnquirySuccess: false,
  sendEnquiryError: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_RESTAURANT_REBATE_PENDING: {
      devLog('info', 'creditRebateReducer: PENDING', { action });
      return {
        ...state,
        error: '',
        pending: true,
        success: false,
      };
    }

    case type.FETCH_RESTAURANT_REBATE_SUCCESS: {
      // Data is already an object, no need to parse
      const rebateData = action.payload?.data;
      devLog('success', 'creditRebateReducer: SUCCESS', {
        fullAction: action,
        payload: action.payload,
        rebateData,
      });
      return {
        ...state,
        data: rebateData || null,
        pending: false,
        success: true,
      };
    }

    case type.FETCH_RESTAURANT_REBATE_FAILURE: {
      devLog('error', 'creditRebateReducer: FAILURE', {
        payload: action.payload,
        error: action.payload,
      });
      return {
        ...state,
        error: action.payload,
        pending: false,
        success: false,
      };
    }

    case type.REQUEST_RESTAURANT_REBATE_PAYOUT_PENDING: {
      const variables = action.payload?.variables || {};
      devLog('info', 'creditRebateReducer: REQUEST_PAYOUT_PENDING', {
        restId: variables.restId,
        requestedAmount: variables.requestedAmount,
        action,
      });
      return {
        ...state,
        requestPayoutError: '',
        requestPayoutPending: true,
        requestPayoutSuccess: false,
      };
    }

    case type.REQUEST_RESTAURANT_REBATE_PAYOUT_SUCCESS: {
      const variables = action.payload?.variables || {};
      devLog('success', 'creditRebateReducer: REQUEST_PAYOUT_SUCCESS', {
        restId: variables.restId,
        requestedAmount: variables.requestedAmount,
        fullAction: action,
        payload: action.payload,
      });
      return {
        ...state,
        requestPayoutPending: false,
        requestPayoutSuccess: true,
        requestPayoutError: '',
      };
    }

    case type.REQUEST_RESTAURANT_REBATE_PAYOUT_FAILURE: {
      const variables = action.payload?.variables || {};
      devLog('error', 'creditRebateReducer: REQUEST_PAYOUT_FAILURE', {
        restId: variables.restId,
        requestedAmount: variables.requestedAmount,
        payload: action.payload,
        error: action.payload,
      });
      return {
        ...state,
        requestPayoutError: action.payload,
        requestPayoutPending: false,
        requestPayoutSuccess: false,
      };
    }
    // success is stored in state so we need a clear case to allow multiple apply credit modal instances
    case type.CLEAR_REQUEST_RESTAURANT_REBATE_PAYOUT: {
      devLog('info', 'creditRebateReducer: CLEAR_REQUEST_PAYOUT');
      return {
        ...state,
        requestPayoutPending: false,
        requestPayoutSuccess: false,
        requestPayoutError: '',
      };
    }

    case type.SEND_MARKETING_FEE_ENQUIRY_PENDING: {
      devLog('info', 'creditRebateReducer: SEND_ENQUIRY_PENDING', { action });
      return {
        ...state,
        sendEnquiryError: '',
        sendEnquiryPending: true,
        sendEnquirySuccess: false,
      };
    }

    case type.SEND_MARKETING_FEE_ENQUIRY_SUCCESS: {
      devLog('success', 'creditRebateReducer: SEND_ENQUIRY_SUCCESS', {
        fullAction: action,
        payload: action.payload,
      });
      return {
        ...state,
        sendEnquiryPending: false,
        sendEnquirySuccess: true,
        sendEnquiryError: '',
      };
    }

    case type.SEND_MARKETING_FEE_ENQUIRY_FAILURE: {
      devLog('error', 'creditRebateReducer: SEND_ENQUIRY_FAILURE', {
        payload: action.payload,
        error: action.payload,
      });
      return {
        ...state,
        sendEnquiryError: action.payload,
        sendEnquiryPending: false,
        sendEnquirySuccess: false,
      };
    }

    default: {
      return state;
    }
  }
};
